export * from './form';
export * from './userStates';
export * from './routes';
export * from './drawdownStates';
export * from './events';
export * from './tnc';
export * from './bankPartners';

export enum EmiPaymentTypes {
  EMI = 'EMI',
  FORECLOSURE = 'FORECLOSURE',
}

export enum EmiPaymentStatus {
  PAID = 'PAID',
  OVERDUE = 'OVERDUE',
  PENDING = 'PENDING',
  DEACTIVATED = 'DEACTIVATED',
}
